import getGlobalModuleQuery from 'lib/contentful/fragments/global-modules';
import { fetchContent } from './api';

const fetchGlobalModule = async (type, locale, preview) => {
  const globalModuleQuery = getGlobalModuleQuery({ name: type, locale, preview });

  if (!globalModuleQuery) {
    throw new Error(`Query not found for global module [${type}]`);
  }

  const response = await fetchContent(globalModuleQuery, preview);
  return response?.globalModuleCollection?.items?.[0];
};

export default fetchGlobalModule;
